import {load} from './common'

export function loadDevices() {
  return load('devices')
}




/** WEBPACK FOOTER **
 ** ./src/app/actions/devices.js
 **/